const ROLES = {
  technician: 'Technician',
  admin: 'Admin',
  cs_user: 'CS User',
  cs_manager: 'CS Manager',
  warehouse: 'Warehouse',
  tech_manager: 'Tech Manager',
}

export { ROLES }
